export default "__VITE_ASSET__BiSx31mA__"